export const GENERIC_NONE_VALUE = "None";
